import { PatientVerificationQuestionnaireItem } from './subsections/patient-verification/questionnaire'
import { HistoryAndDiagnosesQuestionnaireItem } from './subsections/history-and-diagnoses/questionnaire'

// Main section marker
export enum PatientBackgroundSectionQuestionnaireItem {
  PATIENT_BACKGROUND = 'patient-background'
}

export const PatientBackgroundQuestionnaireItem = {
  ...PatientBackgroundSectionQuestionnaireItem,
  ...PatientVerificationQuestionnaireItem,
  ...HistoryAndDiagnosesQuestionnaireItem
} as const

export type PatientBackgroundQuestionnaireItem =
  (typeof PatientBackgroundQuestionnaireItem)[keyof typeof PatientBackgroundQuestionnaireItem]
